import { useSelector } from 'react-redux';

import { selectUserProjectId } from 'core/userContext';
import { Campaign } from 'modules/campaignIndex/types';

/**
 * Used for constructing strings prefixed by user project id. Useful in creating project
 * specific keys for storing data in local storage.
 *
 * Note: the `getProjectId` argument is optional. It's written this way to allow easy
 * overriding in the tests without mocking the redux store.
 */
export const prefixWithUserProject = (
  str: string,
  getProjectId = () => useSelector(selectUserProjectId),
) => {
  const userProjectId = getProjectId();
  return `proj-${userProjectId}-${str}`;
};

export const getStartTime = (campaigns: Campaign[]) => {
  const blastCampaigns = campaigns.filter(
    (campaign) => campaign.campaignTypeDefinition === 'Blast',
  );
  if (blastCampaigns.length === campaigns.length) {
    return blastCampaigns.reduce((earliestStartDate: string, campaign: Campaign) => {
      if (earliestStartDate < campaign.startAt) {
        return new Date(earliestStartDate).toISOString();
      } else {
        return new Date(campaign.startAt).toISOString();
      }
    }, new Date().toISOString());
  } else {
    return campaigns.reduce((earliestCreatedDate: string, campaign: Campaign) => {
      if (earliestCreatedDate < campaign.createdAt) {
        return new Date(earliestCreatedDate).toISOString();
      } else {
        return new Date(campaign.createdAt).toISOString();
      }
    }, new Date().toISOString());
  }
};
